import React from "react";
import { useQuery } from "@apollo/client";
import { FrequentSearch } from "../component/FrequentSearch";
import { SEARCH_RENT_BUSINESS_FACETS_QUERY } from "../../../facets/queries";
import { cleanName } from "@coninsa-site/project/src/utils";
import { capitalizeFirstLetter } from "pages/arrendamientos/vivienda";

export function BussinessFrequentSearch() {
  const { data } = useQuery(SEARCH_RENT_BUSINESS_FACETS_QUERY);

  if (!data) {
    return null;
  }

  const list = data.search.facets[0].values as Array<{
    count: number;
    filter: string;
  }>;

  const formattedList = list.map((item) => {
    return {
      id: item.filter,
      label: `en arriendo en ${capitalizeFirstLetter(item.filter.toLowerCase())}`,
      path: `/arrendamientos/comercio/ciudad/${cleanName(item.filter)}`,
      title: `Inmuebles de comercio en arriendo en ${capitalizeFirstLetter(item.filter.toLowerCase())}`,
    };
  });

  return <FrequentSearch list={formattedList} subTitle="Inmuebles de comercio" />;
}
